import { PRODUCT_NAMES, PRODUCTS_URLS } from '../constants';

const getAccessibleProduct = (productConfig, productName, pathname) => {
  const isActiveProduct = pathname && PRODUCTS_URLS.some(urlDetail => pathname.startsWith(urlDetail.url.toLocaleLowerCase()) && (productName === urlDetail.name || productName === urlDetail.productName));
  return productConfig.IsLicensed && (isActiveProduct || !productConfig.IsInImplementation);
};
/**
 * Returns an array of accessible tab names and their corresponding product configuration based on the product configuration.
 * @example
 * // returns [
 * //   [
 * //     PRODUCT_NAMES.LEARN,
 * //     { IsLicensed: true, IsInImplementation: false },
 * //   ],
 * //   [
 * //     PRODUCT_NAMES.PERFORM,
 * //     { IsLicensed: true, IsInImplementation: true },
 * //   ],
 * //   [
 * //     PRODUCT_NAMES.IDENTITY_ADMIN,
 * //     {},
 * //   ],
 * // ]
 * const accessibleProducts = getAccessibleProducts({
 *   Learn: {
 *     IsLicensed: true,
 *     IsInImplementation: false,
 *   },
 *   Perform: {
 *     IsLicensed: true,
 *     IsInImplementation: true,
 *   },
 *   Suite: {
 *     Ids: {
 *       Url: '',
 *     },
 *   },
 * });
 * @param {object?} productConfig - The product configuration.
 * @returns {[string, object][]} - An array of accessible tab names and their corresponding product configuration.
 */


const getAccessibleProducts = (productConfig = {}) => {
  const configEntries = Object.entries(productConfig).filter(([productName, config]) => getAccessibleProduct(config, productName, window?.location?.pathname?.toLowerCase()));

  if (configEntries.some(([productName]) => productName === PRODUCT_NAMES.SUITE) && productConfig?.Portal?.MyTeam) {
    configEntries.push([PRODUCT_NAMES.TEAM, {}]);
  }

  if (productConfig[PRODUCT_NAMES.SUITE]?.Ids?.Url === '') {
    configEntries.push([PRODUCT_NAMES.IDENTITY_ADMIN, {}]);
  }

  return configEntries;
};

export default getAccessibleProducts;
//# sourceMappingURL=getAccessibleProducts.js.map